import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import prepareQuestionnaireReducer from 'app/features/questionnaires/create/PrepareQuestionnaire/slice';
import taxQuestionnaireReducer from 'app/features/questionnaires/edit/TaxQuestionnaire/reducer';
import api, { publicAPI } from 'app/services';
import { questionnairesApi } from 'app/services/questionnaires';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [api.reducerPath]: api.reducer,
    [publicAPI.reducerPath]: publicAPI.reducer,
    [questionnairesApi.reducerPath]: questionnairesApi.reducer,

    prepareQuestionnaire: prepareQuestionnaireReducer,
    taxQuestionnaire: taxQuestionnaireReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      api.middleware,
      questionnairesApi.middleware,
      publicAPI.middleware,
    ]),
});
setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

const taxQuestionnaire = store.getState().taxQuestionnaire;
const prepareQuestionnaireState = store.getState().prepareQuestionnaire;
const prepareQuestionnaire = store.getState().prepareQuestionnaire;

export type TTaxQuestionnaire = typeof taxQuestionnaire;
export type TPrepareQuestionnaireState = typeof prepareQuestionnaireState;
export type TprepareQuestionnaire = typeof prepareQuestionnaire;

export interface IprepareQuestionnaire extends TprepareQuestionnaire {}
export interface IPrepareQuestionnaireState
  extends TPrepareQuestionnaireState {}
export interface ITaxQuestionnaire extends TTaxQuestionnaire {}
